import { Jumbotron, Tabs, Tab, Image } from 'react-bootstrap';
import '../Temporary.sass';

const Marketing = () => {
    return (
        <>
              <h1>Вакансии компании Синомост</h1>
        </>
    );
};

export default Marketing;
